import { render, staticRenderFns } from "./StudioHeader.vue?vue&type=template&id=efba6ce0&scoped=true"
import script from "./StudioHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioHeader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioHeader.vue?vue&type=style&index=0&id=efba6ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efba6ce0",
  null
  
)

export default component.exports